'use strict';

function saveAnswerToLocalStorage(storageId, questionId, answer) {
  if ( localStorage.getItem(`q_${storageId}`) ) {
    const storageData = JSON.parse(localStorage.getItem(`q_${storageId}`));

    storageData[questionId] = answer;
    handleAnswerStorage(`q_${storageId}`, storageData, questionId);

    return;
  }

  const storageData = {};
  storageData[questionId] = answer;
  handleAnswerStorage(`q_${storageId}`, storageData, questionId);
}

function handleAnswerStorage(storageId, data, lastQuestionId) {
  localStorage.setItem(storageId, JSON.stringify(data));
  localStorage.setItem(`${storageId}LastQuestion`, lastQuestionId);
}

function getQuestionnaireObject(storageId) {
  return localStorage.getItem(`q_${storageId}`) ? JSON.parse(localStorage.getItem(`q_${storageId}`)) : null;
}

function getAnswerFromLocalStorage(storageId, questionId) {
  return localStorage.getItem(`q_${storageId}`) && JSON.parse(localStorage.getItem(`q_${storageId}`))[questionId] || null;
}

function getLastQuestionId(storageId) {
  return localStorage.getItem(`q_${storageId}LastQuestion`) || null;
}

export {
  saveAnswerToLocalStorage,
  getAnswerFromLocalStorage,
  getQuestionnaireObject,
  getLastQuestionId,
};



// WEBPACK FOOTER //
// ./client/utils/questionnaire.js